import { render, staticRenderFns } from "./price.vue?vue&type=template&id=50d684ff&scoped=true&"
import script from "./price.vue?vue&type=script&lang=js&"
export * from "./price.vue?vue&type=script&lang=js&"
import style0 from "./price.vue?vue&type=style&index=0&id=50d684ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d684ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d684ff')) {
      api.createRecord('50d684ff', component.options)
    } else {
      api.reload('50d684ff', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=50d684ff&scoped=true&", function () {
      api.rerender('50d684ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/depth/price.vue"
export default component.exports